export default __webpack_public_path__ + "static/media/symbol-vw.1d726571.svg";